define('app-CarouselJumbotron/settings',[],function () {
    return {
        jumbotronCarousel: $('.carouselJumbotron'),

        jumbotronCarouselUrl: '/jumbotroncarousel/jumbotroncontent',
        jumbotronAnimated: $('.jumbotron--animated'),

        defaultSlideH1: $('.defaultSlide h1'),
        defaultSlideH2: $('.defaultSlide h2'),
        defaultSlideDiv: '<div class="defaultSlide"></div>',

        mobileSlideH1: $('.jumbotronMobile h1'),
        mobileSlideH2: $('.jumbotronMobile h2'),

        contentDataRow2: $('#content [data-rownumber="2"]'),
        contentDataRow3: $('#content [data-rownumber="3"]'),
        contentDataRow4: $('#content [data-rownumber="4"]'),

        carouselIndicators: '<ul class="carousel-indicators" style="z-index:1"><li class="carouselDiscs carouselDisc0"></li><li class="carouselDiscs carouselDisc1"></li><li class="carouselDiscs carouselDisc2"></li><li class="carouselDiscs carouselDisc3"></li></ul>'
    };
});
